"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandlerComponent = exports.ErrorGUITypeEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
var ErrorGUITypeEnum;
(function (ErrorGUITypeEnum) {
    ErrorGUITypeEnum["special"] = "special";
})(ErrorGUITypeEnum || (exports.ErrorGUITypeEnum = ErrorGUITypeEnum = {}));
class ErrorHandlerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            hasError: false,
            info: null,
        };
    }
    componentDidCatch(error, info) {
        this.setState({
            error,
            hasError: true,
            info,
        });
    }
    render() {
        if (!this.state.hasError) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: this.props.children });
        }
        const info = this.state.info.componentStack;
        const type = this.props.type;
        if (type === ErrorGUITypeEnum.special) {
            return ((0, jsx_runtime_1.jsxs)("div", { style: { color: 'black' }, className: "error", children: [(0, jsx_runtime_1.jsx)("b", { children: "Something went wrong" }), (0, jsx_runtime_1.jsx)("details", { style: { cursor: 'pointer' }, children: (0, jsx_runtime_1.jsxs)("div", { style: { color: 'red', cursor: 'default' }, children: [(0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("b", { children: "Error occurred at:" }) }), info] }) })] }));
        }
        return null;
    }
}
exports.ErrorHandlerComponent = ErrorHandlerComponent;
